





















































import { Component, Vue } from 'vue-property-decorator'

import { getTerveyskeskuskoulutusjaksot as getTerveyskeskuskoulutusjaksotVastuuhenkilo } from '@/api/vastuuhenkilo'
import { getTerveyskeskuskoulutusjaksot as getTerveyskeskuskoulutusjaksotVirkailija } from '@/api/virkailija'
import ElsaButton from '@/components/button/button.vue'
import BCardSkeleton from '@/components/card/card.vue'
import { TerveyskeskuskoulutusjaksonVaihe } from '@/types'
import { toastFail } from '@/utils/toast'

@Component({
  components: {
    BCardSkeleton,
    ElsaButton
  }
})
export default class TerveyskeskuskoulutusjaksotCard extends Vue {
  vaiheet: TerveyskeskuskoulutusjaksonVaihe[] | null = null

  get fields() {
    return [
      {
        key: 'erikoistuvanNimi',
        label: this.$t('erikoistuja'),
        sortable: true
      },
      {
        key: 'pvm',
        label: this.$t('pvm'),
        sortable: true
      },
      {
        key: 'actions',
        label: '',
        sortable: false,
        class: 'actions'
      }
    ]
  }

  loading = true

  async mounted() {
    try {
      const avoinParams = {
        page: 0,
        size: 10,
        sort: 'muokkauspaiva,asc',
        avoin: true
      }
      this.vaiheet = (
        await (this.$isVirkailija()
          ? getTerveyskeskuskoulutusjaksotVirkailija(avoinParams)
          : getTerveyskeskuskoulutusjaksotVastuuhenkilo(avoinParams))
      ).data.content
    } catch (err) {
      toastFail(this, this.$t('terveyskeskuskoulutusjaksojen-hakeminen-epaonnistui'))
    }
    this.loading = false
  }

  get rows() {
    return this.vaiheet?.length ?? 0
  }
}
